import { PunchupBadge } from "./PunchupBadge";

interface PublishStatusBadgeProps {
  isPublished: boolean;
  /**
   * GCP video-pipeline status of the linked video, when the special has one.
   * While the special isn't live, this distinguishes a video still processing
   * from one that failed processing — otherwise both look like "Unpublished".
   */
  pipelineStatus?: string | null;
  className?: string;
}

export function PublishStatusBadge({
  isPublished,
  pipelineStatus,
  className,
}: PublishStatusBadgeProps) {
  if (isPublished) {
    return (
      <PunchupBadge className={className} variant="success" label="Published" />
    );
  }

  if (pipelineStatus === "failed") {
    return (
      <PunchupBadge
        className={className}
        variant="danger"
        label="Processing failed"
      />
    );
  }

  if (pipelineStatus === "uploading" || pipelineStatus === "processing") {
    return (
      <PunchupBadge className={className} variant="info" label="Processing" />
    );
  }

  return (
    <PunchupBadge className={className} variant="neutral" label="Unpublished" />
  );
}
